import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7d7e8fb7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tags" }
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = {
  key: 1,
  class: "image-min",
  src: "/img/not_found.jpg",
  alt: "Not Image"
}
const _hoisted_4 = { class: "time center" }
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = {
  key: 1,
  class: "image",
  src: "/img/not_found.jpg",
  alt: "Not Image"
}
const _hoisted_7 = { class: "tags" }
const _hoisted_8 = ["src", "alt"]
const _hoisted_9 = {
  key: 1,
  class: "image-min",
  src: "/img/not_found.jpg",
  alt: "Not Image"
}

import { ref, onBeforeMount, onBeforeUnmount, watch, computed } from "vue";

import { getSamplingPointImagesLabel } from "@/service/image.service";
import { ImageLabelData } from "@/types/Image.type.ts";
import { ImageLabel } from "@/types/imageLabel.type.ts";
import { ArrowLeft, ArrowRight } from "@element-plus/icons-vue";
import { SamplingPoint } from "@/types/samplingpoint.type";
import { getImage } from "@/service/image.service";
import ImageLabelForm from "@/components/issueMonitoring/imageLabel/imageLabelForm.component";
import cloneDeep from "lodash/cloneDeep";
import { Pagination } from "@/types/pagination.type";
import { useRoute } from "vue-router";
import { getImageLabelHistoryByClassification } from "@/service/imageLabelHistory.service.ts";
import { applyFilterBBDD } from "@/utils/imageLabel.util.ts";
import { FilterImagesLabel } from "@/types/imageLabel.type.ts";

type FormFilter = {
  samplingPoint: SamplingPoint;
  fromDateTime: Date;
  toDateTime: Date;
  numberImageLabel: number;
  type: string;
};


export default /*#__PURE__*/_defineComponent({
  props: {
    filters: null,
    images: null,
    imgFilter: null,
    imagesrc: null,
    copy: null,
    labels: null,
    filterImages: null,
    currentImage: null,
    notEdit: { type: Boolean }
  },
  emits: ["updateImages", "updateTotal"],
  setup(__props: any, { expose, emit }: { emit: ({
  (
    e: "updateImages",
    value: ImageLabelData[],
    src: Record<string, string>,
    copy: ImageLabelData[],
    labels: ImageLabelData[]
  ): void;
  (e: "updateTotal", total: number): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  filters: FormFilter;
  images?: Array<ImageLabelData>;
  imgFilter: string;
  imagesrc?: Record<string, string>;
  copy?: Array<ImageLabelData>;
  labels?: Array<ImageLabelData>;
  filterImages?: FilterImagesLabel;
  currentImage?: ImageLabelData;
  notEdit: boolean;
}

const route = useRoute();
const correctRoute = route.path === "/issue-monitoring/samplingpoints/FQConfig";




// índice de la imagen actual en el array allImages
const currentIndex = ref<number>(0);
const currentImage = ref<ImageLabelData>({});
const copyCurrentImage = ref<ImageLabelData>({});
const allImages = ref<ImageLabelData[]>([]);
const copyAllImages = ref<ImageLabelData[]>([]);
const src = ref<Record<string, string>>({});
const labelArray = ref<ImageLabel[]>([]);
const current = ref<number>(0);

/**
 * CARRUSEL
 */
// Array que muestra las imágenes anteriores
const imagesPrevious = ref<ImageLabelData[]>([]);
// Array que muestra las imágenes posteriores
const imagesNext = ref<ImageLabelData[]>([]);
// Índice inicial del carrusel de imagesPrevious que se muestra
const fromIndex = ref<number>(0);
// Índice inicial del carrusel de imagesNext que se muestra
const toIndex = ref<number>(0);

/**
 * Cargar las miniaturas y recuperar el etiquetado
 * @param images
 */
const loadImages = (images: ImageLabelData[]) => {
  images.forEach(async (image) => {
    if (image?.fileName && !src.value[image.fileName]) {
      getImage(image.fileName, true).then((res) => {
        if (image?.fileName) {
          src.value[image.fileName] = res;
        }
        if (image.imageLabel) {
          image.imageLabel.image = { id: image.id };
          image.imageLabel.statusLabel = "warning";
          if (route.query.type === "edit") {
            labelArray.value.push(image.imageLabel);
          }
        }
      });
    }
  });
};

/**
 * Cargar más imágenes
 * @param limit
 */
const uploadMore = async (limit: number) => {
  let imageLabel: Pagination<ImageLabelData> = {};

  //- Recuperar etiquetado ya existente para evitar perdida de datos en cambios de vista

  if (props.images && props.images.length > 0) {
    allImages.value = props.images;
    src.value = props.imagesrc;
    copyAllImages.value = props.copy;
    labelArray.value = props.labels;
    current.value++;
  }

  const fromDateTime =
    allImages.value.length === 0
      ? props.filters.fromDateTime
      : allImages.value[allImages.value.length - 1].dateTime.toString();
  if (route.query.classification && route.query.type === "view") {
    const filters = applyFilterBBDD(props.filterImages, "imageLabelHistory");
    imageLabel = await getImageLabelHistoryByClassification(
      route.query.classification,
      props.filters.samplingPoint.id,
      current.value,
      limit,
      fromDateTime,
      props.filters.toDateTime,
      filters.fields ? filters : undefined
    );
    current.value++;
  } else {
    const filters = applyFilterBBDD(props.filterImages, "imageLabel");
    imageLabel = await getSamplingPointImagesLabel(
      `${props.filters.samplingPoint.id}`,
      current.value,
      limit,
      fromDateTime,
      props.filters.toDateTime,
      undefined,
      props.filters.cameras,
      filters.fields ? filters : undefined
    );
    current.value++;
  }

  const data = imageLabel.data;

  const isFirstQuery = fromDateTime === props.filters.fromDateTime;

  if (isFirstQuery) {
    emit("updateTotal", imageLabel.totalRows);
  }
  // const currentPage = imageLabel.currentPage;

  // updatedCurrentPage = currentPage;

  if (data && data.length > 0) {
    allImages.value.push(...data);
    copyAllImages.value.push(...cloneDeep(data));
    loadImages(data);
  }

  getImagesToDisplay();
};

const getImagesMultiple = () => {
  currentIndex.value = allImages.value.findIndex((img) => img.id === props.currentImage.id);

  fromIndex.value =
    currentIndex.value - props.filters.numberImageLabel > 0
      ? currentIndex.value - props.filters.numberImageLabel
      : 0;
  toIndex.value =
    currentIndex.value < allImages.value.length
      ? currentIndex.value + props.filters.numberImageLabel
      : allImages.value.length;
};
/**
 * Obtener las imágenes que se van a mostrar
 */
const getImagesToDisplay = () => {
  let filtered = allImages.value.filter((img) => {
    if (props.imgFilter === "with") return img.hasSamples;
    if (props.imgFilter === "without") return !img.hasSamples;
    return true;
  });

  // - filtered = applyFiltersImages(allImages.value, props.filterImages);

  //- imagen actual
  currentImage.value = filtered.length > 0 ? filtered[currentIndex.value] : null;
  copyCurrentImage.value = copyAllImages.value.find((img) => img.id === currentImage.value.id);

  //- Obtener las imágenes del carrusel
  imagesPrevious.value = filtered.slice(
    Math.max(0, currentIndex.value - props.filters.numberImageLabel),
    currentIndex.value
  );
  imagesNext.value = filtered.slice(
    currentIndex.value + 1,
    currentIndex.value + 1 + props.filters.numberImageLabel
  );
};

/**
 * Recuperar la imagen anterior
 */
const previousImage = () => {
  currentIndex.value -= 1;
  if (fromIndex.value > 0) {
    fromIndex.value -= 1;
  }
  if (toIndex.value - currentIndex.value > props.filters.numberImageLabel) {
    toIndex.value -= 1;
  }

  getImagesToDisplay();
};

/**
 * Recuperar la siguiente imagen
 */
const nextImage = async () => {
  currentIndex.value += 1;

  if (toIndex.value + 1 === allImages.value.length) {
    await uploadMore(props.filters.numberImageLabel * 2 + 1);
  }
  if (currentIndex.value - fromIndex.value > props.filters.numberImageLabel) {
    fromIndex.value += 1;
  }

  if (toIndex.value < allImages.value.length) {
    toIndex.value += 1;
  }

  getImagesToDisplay();
};

/**
 * Actualizar valores
 * @param label
 * @param lighting
 */
const updateImages = (label: string | undefined, lighting: string | undefined) => {
  //- Actualizar imagen principal
  if (!currentImage.value.imageLabel) {
    currentImage.value.imageLabel = {} as ImageLabel;
    currentImage.value.imageLabel.image = { id: currentImage.value.id };
  }
  if (label) {
    currentImage.value.imageLabel.label = label;
  }
  if (lighting) {
    currentImage.value.imageLabel.lighting_condition = lighting;
  }

  if (currentImage.value.imageLabel.lighting_condition && currentImage.value.imageLabel.label) {
    currentImage.value.imageLabel.statusLabel = "success";
  }

  const indexImageLabel = labelArray.value?.findIndex((_) => _.image.id == currentImage.value.id);
  if (indexImageLabel != undefined && indexImageLabel >= 0) {
    labelArray.value[indexImageLabel].lighting_condition =
      currentImage.value.imageLabel.lighting_condition;
    labelArray.value[indexImageLabel].label = currentImage.value.imageLabel.label;
    labelArray.value[indexImageLabel].statusLabel = currentImage.value.imageLabel.statusLabel;
  } else {
    const imageLabel = {} as ImageLabel;
    imageLabel.lighting_condition = currentImage.value.imageLabel.lighting_condition;
    imageLabel.label = currentImage.value.imageLabel.label;
    imageLabel.image = { id: currentImage.value.id };
    imageLabel.statusLabel = currentImage.value.imageLabel.statusLabel;

    labelArray.value.push(imageLabel);
  }

  emit("updateImages", allImages.value, src.value, copyAllImages.value, labelArray.value);
};

/**
 * Obtener el valor actualizado de lighting_condition
 * @param valor
 */
const getUpdateLighting = (valor: string) => {
  updateImages(undefined, valor);
};

/**
 * Obtener el valor actualizado de label
 * @param valor
 */
const getLabel = (valor: string) => {
  updateImages(valor, undefined);
};

/**
 * Moverse hacia delante o hacia atras
 * @param event
 */
const handleKeydown = (event: Event) => {
  if (event.key === "ArrowRight" && currentIndex.value != allImages.value.length - 1) {
    nextImage();
  } else if (event.key === "ArrowLeft" && currentIndex.value != 0) {
    previousImage();
  }
};

const filteredImagesPrevious = computed(() =>
  imagesPrevious.value.filter((img) => {
    if (props.imgFilter === "with") return img.hasSamples;
    if (props.imgFilter === "without") return !img.hasSamples;
    return true;
  })
);

const filteredImagesNext = computed(() =>
  imagesNext.value.filter((img) => {
    if (props.imgFilter === "with") return img.hasSamples;
    if (props.imgFilter === "without") return !img.hasSamples;
    return true;
  })
);

onBeforeMount(() => {
  const limit = props.filters.numberImageLabel * 2 + 1;
  toIndex.value = props.filters.numberImageLabel;
  uploadMore(limit);

  if (props.notEdit && props.currentImage.id) {
    getImagesMultiple();
  }
  window.addEventListener("keydown", handleKeydown);
});

onBeforeUnmount(() => {
  window.removeEventListener("keydown", handleKeydown);
});

expose({
  labelArray,
  allImages,
  src,
  copyAllImages,
});

return (_ctx: any,_cache: any) => {
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_col = _resolveComponent("el-col")!

  return (_openBlock(), _createBlock(_component_el_row, { gutter: 8 }, {
    default: _withCtx(() => [
      _createVNode(_component_el_col, { lg: 17 }, {
        default: _withCtx(() => [
          _createVNode(_component_el_row, {
            class: "imagenes-container center first",
            style: _normalizeStyle({ gridTemplateColumns: `repeat(${props.filters.numberImageLabel}, 1fr)` })
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(filteredImagesPrevious), (img, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: _normalizeClass(["imagen-card", { 'has-samples': img.hasSamples && correctRoute }])
                }, [
                  _createElementVNode("div", _hoisted_1, [
                    _createVNode(_component_el_tag, {
                      type: 
                img.imageLabel && img.imageLabel.statusLabel ? img.imageLabel.statusLabel : 'info'
              
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(img?.dateTime
                  ? _ctx.$d(new Date(img?.dateTime?.toLocaleString()), "dateTimeNoSecs").replace(",", "")
                  : "-"), 1)
                      ]),
                      _: 2
                    }, 1032, ["type"]),
                    _createVNode(_component_el_tag, { type: "info" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(img?.nameTmoa || img?.camera), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  (src.value[img?.fileName])
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: src.value[img?.fileName],
                        alt: img?.filename,
                        class: "image-min"
                      }, null, 8, _hoisted_2))
                    : (_openBlock(), _createElementBlock("img", _hoisted_3))
                ], 2))
              }), 128))
            ]),
            _: 1
          }, 8, ["style"]),
          _createVNode(_component_el_row, { class: "header-image center" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_button, {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (previousImage())),
                disabled: currentIndex.value === 0
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(ArrowLeft))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["disabled"]),
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_el_tag, {
                  type: 
              currentImage.value && currentImage.value.imageLabel && currentImage.value.imageLabel.statusLabel
                ? currentImage.value.imageLabel.statusLabel
                : 'info'
            
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(currentImage.value?.dateTime
                ? _ctx.$d(new Date(currentImage.value?.dateTime?.toLocaleString()), "dateTimeNoSecs").replace(
                    ",",
                    ""
                  )
                : "-"), 1)
                  ]),
                  _: 1
                }, 8, ["type"]),
                _createVNode(_component_el_tag, { type: "info" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(currentImage.value?.nameTmoa || currentImage.value?.camera), 1)
                  ]),
                  _: 1
                })
              ]),
              _createVNode(_component_el_button, {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (nextImage())),
                disabled: currentIndex.value === allImages.value.length - 1
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(ArrowRight))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["disabled"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_row, { class: "body center" }, {
            default: _withCtx(() => [
              (currentImage.value && currentImage.value.fileName && src.value[currentImage.value.fileName])
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    class: "image",
                    src: src.value[currentImage.value.fileName],
                    alt: currentImage.value.fileName
                  }, null, 8, _hoisted_5))
                : (_openBlock(), _createElementBlock("img", _hoisted_6))
            ]),
            _: 1
          }),
          _createVNode(_component_el_row, {
            class: "imagenes-container center second",
            style: _normalizeStyle({ gridTemplateColumns: `repeat(${props.filters.numberImageLabel}, 1fr)` })
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(filteredImagesNext), (img2, index2) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index2,
                  class: _normalizeClass(["imagen-card", { 'has-samples': img2.hasSamples && correctRoute }])
                }, [
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(_component_el_tag, {
                      type: 
                img2.imageLabel && img2.imageLabel.statusLabel
                  ? img2.imageLabel.statusLabel
                  : 'info'
              
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(img2?.dateTime
                  ? _ctx.$d(new Date(img2?.dateTime?.toLocaleString()), "dateTimeNoSecs").replace(
                      ",",
                      ""
                    )
                  : "-"), 1)
                      ]),
                      _: 2
                    }, 1032, ["type"]),
                    _createVNode(_component_el_tag, { type: "info" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(img2?.nameTmoa || img2?.camera), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  (src.value[img2?.fileName])
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: src.value[img2?.fileName],
                        alt: img2?.filename,
                        class: "image-min"
                      }, null, 8, _hoisted_8))
                    : (_openBlock(), _createElementBlock("img", _hoisted_9))
                ], 2))
              }), 128))
            ]),
            _: 1
          }, 8, ["style"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_col, { lg: 7 }, {
        default: _withCtx(() => [
          _createVNode(_unref(ImageLabelForm), {
            onUpdateLighting: getUpdateLighting,
            onUpdateLabel: getLabel,
            image: copyCurrentImage.value,
            updatedLabel: currentImage.value,
            formFilter: __props.filters,
            notEdit: props.notEdit
          }, null, 8, ["image", "updatedLabel", "formFilter", "notEdit"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})